import { parse, format } from 'date-fns';
import { dateFormatEn } from '@shared/lib/constants';
export const formatShippingDate = (date, dateFormat) => {
    const parsedDate = parse(date, dateFormatEn, new Date());
    return format(parsedDate, dateFormat);
};
